import { PropsWithChildren } from 'react'

type ContentProps = {}

export const Content = ({ children }: PropsWithChildren<ContentProps>) => {
  return <div className="flex flex-col w-full gap-4">{children}</div>
}
